import {
    ALIGN_BOTTOM_BETWEEN_OBJECTS_LINE_ID,
    ALIGN_LEFT_BETWEEN_OBJECTS_LINE_ID,
    ALIGN_RIGHT_BETWEEN_OBJECTS_LINE_ID,
    ALIGN_TOP_BETWEEN_OBJECTS_LINE_ID,
    H_LINE_ID, HORIZONTAL_LINE_OF_INTERSECT_IN_CENTER_OF_OBJECTS,
    V_LINE_ID, VERTICAL_LINE_OF_INTERSECT_IN_CENTER_OF_OBJECTS
} from "@/common/preview/positioning-lines";
import { ShowPageScopeCollector } from '@frontend/group/modules/scope-collectors/show-page-collector';
import { translateTemplateImageEventBroker, EVENTS } from './event-broker';
import { FIELD_TYPE_BACKGROND_THEME_IMAGE } from "@frontend/constants/type-fields-of-template";
import { DEFAULT_BACKGROUND_THEME_IMAGE_FIELD_PROPERTIES } from '@frontend/group/modules/additional-fields'

const NOT_PROCESSED_OBJECTS = [
    'pixel_background',
    H_LINE_ID,
    V_LINE_ID,
    ALIGN_TOP_BETWEEN_OBJECTS_LINE_ID,
    ALIGN_BOTTOM_BETWEEN_OBJECTS_LINE_ID,
    ALIGN_LEFT_BETWEEN_OBJECTS_LINE_ID,
    VERTICAL_LINE_OF_INTERSECT_IN_CENTER_OF_OBJECTS,
    HORIZONTAL_LINE_OF_INTERSECT_IN_CENTER_OF_OBJECTS,
    ALIGN_RIGHT_BETWEEN_OBJECTS_LINE_ID,
];

const getShowPageScope = () => ShowPageScopeCollector.get([
    'previews',
    'layoutChanges',
    'getChangesLayoutById',
    'saveLayout',
    'updateLayoutChanges',
    'handleObjectMoving',
    'onClickDuplicateTemplateButton',
]);

let currentPreview = null;

translateTemplateImageEventBroker.on(EVENTS.SAVED, async (state) => {
    // ...
});

export const getObjectsForOrder = (objects) => objects
    .filter(object => !NOT_PROCESSED_OBJECTS.includes(object.id))
    .map(object => {
        if (object.get('type') === 'group') {
            const objects = object.getObjects();
            return {
                name: 'Group',
                isGroup: true,
                target: object,
                id: object.id,
                visible: false,
                objects: getObjectsForOrder(objects),
            }
        }

        return {
            name: object?.templateField?.name || object?.name,
            target: object,
            objects: [],
            id: object.id,
        }
    });

const generateThumbnailFromObject = (
  fabricObject,
  maxSize = 40,
  format = 'jpeg'
) => {
  try {
    if (!fabricObject || !fabricObject._element) return null;

    // Create a temporary canvas to generate a small thumbnail
    const tempCanvas = document.createElement('canvas');
    const ctx = tempCanvas.getContext('2d');

    const element = fabricObject._element;
    const originalWidth = element.naturalWidth || element.width || 100;
    const originalHeight = element.naturalHeight || element.height || 100;

    // Calculate scaled dimensions maintaining aspect ratio
    const scale = Math.min(
      maxSize / originalWidth,
      maxSize / originalHeight
    );

    const width = Math.round(originalWidth * scale);
    const height = Math.round(originalHeight * scale);

    tempCanvas.width = width;
    tempCanvas.height = height;

    ctx.drawImage(element, 0, 0, width, height);

    if (format === 'png') {
      return tempCanvas.toDataURL('image/png');
    }

    return tempCanvas.toDataURL('image/jpeg', 0.6);
  } catch (e) {
    // If CORS or other errors, return null
    return null;
  }
};

const handlerButton = (instanceId) => {
    const { previews } = getShowPageScope();

    const preview = previews.find(preview => preview.id === instanceId);
    currentPreview = preview;

    const objects = getObjectsForOrder(preview.canvas.getObjects());

    const fields = objects.map(object => {
        let thumbnail = null;
        let url = null;

        if (object.target._element) {
            const currentSrc = object.target._element.currentSrc;
            url = currentSrc ? new URL(currentSrc) : null;

            // Generate thumbnail from canvas element (fast, no network request)
            thumbnail = generateThumbnailFromObject(object.target, 40, 'png');
        }

        return {
            id: object.target.id,
            name: object.name,
            type: object.target.templateField?.type || FIELD_TYPE_BACKGROND_THEME_IMAGE,
            thumbnail: thumbnail || DEFAULT_BACKGROUND_THEME_IMAGE_FIELD_PROPERTIES.additional_background_images,
            url: url || DEFAULT_BACKGROUND_THEME_IMAGE_FIELD_PROPERTIES.additional_background_images,
        }
    })

    translateTemplateImageEventBroker.fire(EVENTS.INIT, {
        fields,
        preview,
        objects: objects,
    });
}

export function initBatchTranslateHandler() {
    $('.btn-layout-batch-translate').on('click', function () {
        const { previews } = getShowPageScope();

        const templates = previews.map(preview => {
            const objects = getObjectsForOrder(preview.canvas.getObjects());

            const fields = objects.map(object => {
                let thumbnail = null;
                let url = null;

                if (object.target._element) {
                    const currentSrc = object.target._element.currentSrc;
                    url = currentSrc ? new URL(currentSrc) : null;
                    thumbnail = generateThumbnailFromObject(object.target);
                }

                return {
                    id: object.target.id,
                    name: object.name,
                    type: object.target.templateField?.type || FIELD_TYPE_BACKGROND_THEME_IMAGE,
                    thumbnail: thumbnail || DEFAULT_BACKGROUND_THEME_IMAGE_FIELD_PROPERTIES.additional_background_images,
                    url: url || DEFAULT_BACKGROUND_THEME_IMAGE_FIELD_PROPERTIES.additional_background_images,
                }
            });

            return {
                instanceId: preview.id,
                fields,
                preview,
                objects,
            };
        });

        translateTemplateImageEventBroker.fire(EVENTS.BATCH_INIT, { templates });
    });
}

export function initTranslateTemplateImageHandler($row) {
    const $button = $row.find('.translate-image');

    $button.on('click', function () {
        // Use .attr() instead of .data() to always read current DOM value
        // jQuery's .data() caches values, which causes issues when Vue updates the attribute
        const id = $(this).attr('data-id');
        handlerButton(id);
    });
}
